import styled from 'styled-components';

export const sharedStyles = `
  font-family: 'Noto Sans';
  font-style: normal;
  line-height: 150%;
  color: #000000;
  white-space: pre-wrap;
`;
export const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 150%;
  color: #484848;
  margin-top: ${(props) => props.margin || '0px'};
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #000000;
  margin-top: ${(props) => props.margin || '0px'};
`;

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: ${(props) => props.marginBottom || '0px'};
  @media (max-width: 1024px) {
    margin-bottom: 0px;
    width: 95% !important;
    margin-top: 0px;
    margin-bottom: 30px;
    padding: 0px 15px;
    box-sizing: border-box;
  }
`;
export const Centered = styled.div`
  display: flex;
  justify-content: center;
`;

export const VariableText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 400};
  font-size: ${(props) => props.Size || '16px'};
  line-height: ${(props) => props.lineHeight || '150%'};
  text-align: center;
  color: ${(props) => props.color || '#000000'};
  white-space: pre-wrap;
  width: 50%;
  margin-top: ${(props) => props.marginTop || '0px'};
`;

export const StyledText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 400};
  font-size: ${(props) => props.Size || '16px'};
  line-height: normal;
  color: ${(props) => props.color || '#000000'};
`;

export const CustomBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${(props) => props.marginTop || '0px'};
  margin-bottom: ${(props) => props.marginBottom || '0px'};
`;

export const HeadingMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: #484848;
  margin-top: ${(props) => props.margin || '0px'};
`;
